import { Radio, Spinner, Typography } from '@material-tailwind/react'
import capitalize from 'lodash/capitalize'
import { useTranslation } from 'react-i18next'

import { useAgamiMediaTypes } from '../hooks/useAgamiMediaTypes'
import { SPOT_MEDIA_TYPES } from '../utils/constants/db.constants'

interface AgamiMediaTypeSelectorProps {
  value: number
  onChange: (value: number) => void
  allowedTypes?: readonly number[]
  disabledTypes?: readonly number[]
  disabled?: boolean
}

const AgamiMediaTypeSelector: React.FC<AgamiMediaTypeSelectorProps> = ({
  value,
  onChange,
  allowedTypes,
  disabledTypes = [],
  disabled,
}) => {
  const { t } = useTranslation()
  const { mediaTypes, isLoading } = useAgamiMediaTypes()

  const labelOf = (type: number, databaseLabel: string) =>
    capitalize(type === SPOT_MEDIA_TYPES.NONE ? t('agami.mediaTypes.none') : databaseLabel)

  return (
    <div
      className="w-full flex flex-col bg-white dark:bg-primary rounded-lg p-4 shadow-sm gap-4"
      data-testid="agami-media-type-selector"
    >
      <Typography className="font-bold text-primary text-xl font-barlow">
        {t('upload.mediaType.title')}
      </Typography>
      {isLoading ? (
        <Spinner className="w-6 h-6" />
      ) : (
        <div className="flex gap-1 justify-start items-center">
          {mediaTypes &&
            Object.entries(mediaTypes)
              .filter(([id]) => !allowedTypes || allowedTypes.includes(Number(id)))
              .map(([id, databaseLabel]) => {
                const type = Number(id)
                return (
                  <Radio
                    key={id}
                    type="radio"
                    value={type}
                    checked={value === type}
                    onChange={() => onChange(type)}
                    label={labelOf(type, databaseLabel)}
                    disabled={disabled || disabledTypes.includes(type)}
                    data-testid={`agami-media-type-radio-${databaseLabel}`}
                    labelProps={{ className: 'text-gray-600 dark:!text-base-gray-500' }}
                  />
                )
              })}
        </div>
      )}
    </div>
  )
}

export default AgamiMediaTypeSelector
